// @flow
import i18n from 'i18next';
import UserTypes from '../action-types/user';

import firebase from '../firebase';
import { users } from '../services/api/ava';
import { users as saasUsers } from '../services/api/saas';
import type { IOrganization } from '../modules/account/models/organization';

// $FlowFixMe
export const updateUserFeaturesRequest = () => ({
  type: UserTypes.UPDATE_USER_FEATURES_REQUEST,
});

// $FlowFixMe
export const updateUserFeaturesSuccess = ({ features }) => ({
  type: UserTypes.UPDATE_USER_FEATURES_SUCCESS,
  payload: features,
});

export const updateUserFeaturesFailure = (errorMessage: string) => ({
  type: UserTypes.UPDATE_USER_FEATURES_FAILURE,
  payload: errorMessage,
});

export const updateUserFeaturesRequestAsync = ({ avaId, features }: { avaId: string, features: Object }) => {
  // $FlowFixMe
  return async dispatch => {
    dispatch(updateUserFeaturesRequest());

    try {
      const firebaseUser = firebase.auth().currentUser;
      if (!firebaseUser) return;

      await users.updateFeatures({ avaId, firebaseAuthUID: firebaseUser.uid, features });

      dispatch(updateUserFeaturesSuccess({ features }));
    } catch (err) {
      dispatch(updateUserFeaturesFailure(err.message));
    }
  };
};

export const updateUserHearingProfileRequest = () => ({
  type: UserTypes.UPDATE_USER_HEARING_PROFILE_REQUEST,
});

export const updateUserHearingProfileSuccess = (hearingProfile: number) => ({
  type: UserTypes.UPDATE_USER_HEARING_PROFILE_SUCCESS,
  payload: hearingProfile,
});

export const updateUserHearingProfileFailure = (errorMessage: string) => ({
  type: UserTypes.UPDATE_USER_HEARING_PROFILE_FAILURE,
  payload: errorMessage,
});

export const updateUserHearingProfileRequestAsync = (hearingProfile: number) => {
  // $FlowFixMe
  return async (dispatch, getState) => {
    dispatch(updateUserHearingProfileRequest());
    const {
      scribeSession: {
        captioner: { avaId, firebaseAuthUID },
      },
    } = getState();

    try {
      await users.updateHearingProfile({ avaId, firebaseAuthUID, hearingProfile });
      dispatch(updateUserHearingProfileSuccess(hearingProfile));
    } catch (err) {
      dispatch(updateUserHearingProfileFailure(err.message));
    }
  };
};

export const updateUserNameRequest = () => ({
  type: UserTypes.UPDATE_USER_NAME_REQUEST,
});

export const updateUserNameSuccess = (userName: string) => ({
  type: UserTypes.UPDATE_USER_NAME_SUCCESS,
  payload: userName,
});

export const updateUserNameFailure = (errorMessage: string) => ({
  type: UserTypes.UPDATE_USER_NAME_FAILURE,
  payload: errorMessage,
});

export const updateUserNameRequestAsync = (userName: string) => {
  // $FlowFixMe
  return async (dispatch, getState) => {
    dispatch(updateUserNameRequest());

    const {
      scribeSession: {
        captioner: { avaId, firebaseAuthUID },
      },
    } = getState();

    try {
      await users.updateUserName({ avaId, firebaseAuthUID, userName });
      dispatch(updateUserNameSuccess(userName));
    } catch (err) {
      dispatch(updateUserNameFailure(err.message));
    }
  };
};

export const setUpdateUserNameSuccess = (value: boolean) => ({
  type: UserTypes.SET_UPDATE_USER_NAME_SUCCESS,
  payload: value,
});

export const setUserOrganization = (org: IOrganization | null) => ({
  type: UserTypes.SET_ORGANIZATION,
  payload: org,
});

export const getUserOrganization = () => {
  return async (dispatch: Function, getState: Function) => {
    let org = null;
    try {
      const { language } = i18n;
      const res = await saasUsers.getUser(language);
      org = res.data.organization;
    } catch (e) {}
    dispatch(setUserOrganization(org));
  };
};
